import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-split-pdf',
    imports: [],
    templateUrl: './blog-split-pdf.component.html',
    styleUrl: './blog-split-pdf.component.css'
})
export class BlogSplitPdfComponent {

}
